var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeStandby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 11.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_1",
    "data-name": "Union 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.24,6.5l0,0,0,0,0,0h0a3.56,3.56,0,0,1-.2-5,3.19,3.19,0,0,1,.26-.26A4.42,4.42,0,0,1,7,1.05H7a4.42,4.42,0,0,1,5.79.06,3.58,3.58,0,0,1,.32,5l-.26.26h0l0,0,0,0,0,0L7,11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7,10.42l5.09-4.66h0l0,0h0l0,0A2.62,2.62,0,0,0,13,3.76a2.61,2.61,0,0,0-.89-1.91A3.27,3.27,0,0,0,9.86,1a3.36,3.36,0,0,0-2.2.8l0,0L7,2.39H7l-.62-.56,0,0A3.36,3.36,0,0,0,4.14,1a3.27,3.27,0,0,0-2.25.85A2.61,2.61,0,0,0,1,3.76a2.62,2.62,0,0,0,.84,1.93l0,0h0l0,0h0L7,10.42m0,1.35L1.24,6.49l0,0,0,0,0,0h0a3.57,3.57,0,0,1,.06-5.3A4.34,4.34,0,0,1,4.14,0,4.34,4.34,0,0,1,7,1.05H7a4.42,4.42,0,0,1,5.79.06,3.57,3.57,0,0,1,.06,5.3h0l0,0,0,0,0,0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeStandby);
export default __webpack_public_path__ + "static/media/like_standby.5e2623e353b3f7259d6d717d4bcd650b.svg";
export { ForwardRef as ReactComponent };